import { render, staticRenderFns } from "./RegisterSongStep1EnterSongDetails.vue?vue&type=template&id=64224fd4&scoped=true"
import script from "./RegisterSongStep1EnterSongDetails.vue?vue&type=script&lang=ts"
export * from "./RegisterSongStep1EnterSongDetails.vue?vue&type=script&lang=ts"
import style0 from "./RegisterSongStep1EnterSongDetails.vue?vue&type=style&index=0&id=64224fd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64224fd4",
  null
  
)

export default component.exports